import CampaignCreationView from './CampaignCreationView';

export default CampaignCreationView;
